import {
  SearchOutlined,
  SettingOutlined,
  StopOutlined,
} from "@ant-design/icons";
import { ProfilesProperties } from "@type/core/auth/auth.types";

export enum ProfileEnum {
  APP_ADMIN = "APP_ADMIN",
  AUDITOR = "AUDITOR",
  NO_RIGHT = "NO_RIGHT",
  COLLABORATOR = "COLLABORATOR",
}

export const profilesProperties: ProfilesProperties = {
  [ProfileEnum.APP_ADMIN]: {
    id: ProfileEnum.APP_ADMIN,
    label: "users.labels.profiles.APP_ADMIN.label",
    icon: <SettingOutlined />,
    description: "users.labels.profiles.APP_ADMIN.description",
    level: 1,
  },
  [ProfileEnum.AUDITOR]: {
    id: ProfileEnum.AUDITOR,
    label: "users.labels.profiles.AUDITOR.label",
    icon: <SearchOutlined />,
    description: "users.labels.profiles.AUDITOR.description",
    level: 2,
  },
  [ProfileEnum.NO_RIGHT]: {
    id: ProfileEnum.NO_RIGHT,
    label: "users.labels.profiles.NO_RIGHT.label",
    icon: <StopOutlined />,
    description: "users.labels.profiles.NO_RIGHT.description",
    level: 4,
  },
  [ProfileEnum.COLLABORATOR]: {
    id: ProfileEnum.COLLABORATOR,
    label: "users.labels.profiles.COLLABORATOR.label",
    icon: <StopOutlined />,
    description: "users.labels.profiles.COLLABORATOR.description",
    level: 4,
  },
};
